<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">AI Model</h2>
      <br />
      <el-button style="float: right; margin-right: 30px" @click="Create()"
        >Create</el-button
      >
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
            <el-form-item label="Customer" prop="customer">
              <el-select
                @change="load"
                v-model="query.customer"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>

        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table
            v-loading="loading"
            :data="searchResult.models"
            class="border"
          >
            <el-table-column prop="name" label="Name" />
            <el-table-column prop="status" label="Status" width="100px" />
            <el-table-column prop="createdAt" label="createdAt" />
            <el-table-column prop="customer" label="Customer" />
            <el-table-column prop="config.startDate" label="StartDate" />
            <el-table-column prop="config.endDate" label="EndDate" />
            <el-table-column prop="published" label="Published">
              <template slot-scope="scope">
                {{ scope.row.published ? "Yes" : "No" }}
              </template>
            </el-table-column>
            <el-table-column prop="path" label="Point">
              <template slot-scope="scope">
                {{ scope.row.path.join(" > ") }}
              </template>
            </el-table-column>

            <el-table-column width="220px">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.report"
                  size="mini"
                  @click="downloadReport(scope.row)"
                  >PDF</el-button
                >
                <el-button
                  v-if="scope.row.model"
                  size="mini"
                  @click="downloadModel(scope.row)"
                  > ↓</el-button
                >
                <el-button size="mini" @click="openModelDetail(scope.row)">
                  Details
                </el-button>
                <span stlye="float:left; margin-left:10px" v-if="scope.row.errorReason">
                  <el-popover
                    placement="left-end"
                    width="500"
                    style="max-height: 300px"
                    trigger="hover"
                  >
                    <p style="max-height: 300px; overflow-y: auto">
                      {{ scope.row.errorReason }}
                    </p>
                    <i
                      class="color-circle"
                      style="background-color: red"
                      slot="reference"
                      >Error</i
                    >
                  </el-popover>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>

    <el-dialog width="60%" title="Create AI Model" :visible.sync="showForm">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="130px"
      >
        <el-form-item label="Name" prop="name">
          <el-input style="width: 200px" v-model="form.name" />
        </el-form-item>
        <el-form-item label="Customer" prop="customer">
          <el-select
            filterable
            v-model="form.customer"
            placeholder="Select"
            clearable
          >
            <el-option
              v-for="item in customerSelect"
              :key="item.value"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Date">
          <el-date-picker
            v-model="form.dateRange"
            type="datetimerange"
            :picker-options="pickerOptions"
            :format="pickerOptions.format"
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            align="right"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="Point Id" prop="pointId">
          <el-input
            placeholder="Please input"
            v-model="form.pointId"
          ></el-input>
        </el-form-item>
        <el-form-item label="Algorihm" prop="algorithm">
          <el-select v-model="form.algorithm" placeholder="Select" clearable>
            <el-option
              key="clustering"
              label="clustering"
              value="clustering"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Features" prop="features">
          <el-select v-model="form.features" placeholder="Select" clearable>
            <el-option
              key="spectral"
              label="spectral"
              value="spectral"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="CreateAIModel()">Create</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import ai_service from "../service/aiModel";
export default {
  name: "AIModel",
  data() {
    return {
      prePrintValue: "",
      query: {
        point: "",
        customer: "",
        page: 1,
        pageSize: 10,
      },
      pickerOptions: {
        format: "DD-MM-YYYY HH:mm:ss"
          .replace(/D/g, "d") //element ui date format require lowercase
          .replace(/Y/g, "y"),
        shortcuts: [
          {
            text: "Last Day",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 * 4);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 Month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 * 4 * 3);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pageSizes: [10, 25, 50, 75],
      editId: "",
      showForm: false,
      formLoading: false,
      certs: {},
      showCertsForm: false,
      form: {
        customer: "",
        pointId: "",
        algorithm: "",
        features: "",
        dateRange: "",
      },
      rules: {
        customer: [
          {
            required: true,
            message: "Please select customer",
            trigger: "blur",
          },
        ],

        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
        point: [
          { required: true, message: "Please input point", trigger: "blur" },
        ],
        dateRange: [
          {
            required: true,
            message: "Please select dateRange",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getAIModels(this.query);
    this.getCustomers();
  },
  computed: {
    ...mapState("aiModel", ["searchResult", "loading"]),
    ...mapState("partner", ["customers", "partners"]),

    customerSelect() {
      return this.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
  },
  methods: {
    //  path:'ai-model/:modelId',
    //   name:'aimodelDetail',
    openModelDetail(row) {
      this.$router.push({
        name: "aimodelDetail",
        params: { modelId: row._id },
      });
    },
    loadCustomersForCreateAIModel() {
      return this.getCustomers({ partner: this.form.partner });
    },
    async loadCustomers() {
      this.query.customer = "";
      this.form.customer = "";
      await this.loadCustomersOnly();
      await this.load();
    },
    ...mapActions("aiModel", ["getAIModels", "createAIModel"]),
    ...mapActions("partner", ["getPartners", "getCustomers"]),
    async downloadModel(row) {
      this.prePrintValue = row;
      this.previewShowForm = true;
      let a = await ai_service.getAIModelSignedUrl(row._id);
      this.downloadUrl(a.url);
    },
    async downloadReport(row) {
      this.prePrintValue = row;
      this.previewShowForm = true;
      let a = await ai_service.getAIReportSignedUrl(row._id);
      this.downloadUrl(a.url);
    },
    downloadUrl(href) {
      window.open(href, "Download");
    },
    load() {
      this.getAIModels(this.query);
    },
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    CreateAIModel() {
      this.$confirm("Are you sure?", "Warning", {
        confirmButtonText: "Yes, send",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.formLoading = true;
            this.createAIModel({
              customer: this.form.customer,
              pointId: this.form.pointId,
              startDate: moment(this.form.dateRange[0]).format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              endDate: moment(this.form.dateRange[1]).format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              algorithm: this.form.algorithm,
              features: this.form.features,
            })
              .finally(() => {
                this.showForm = false;
                this.formLoading = false;
                this.load();
              })
              .catch((e) => {
                this.$message.error(e);
              });
          }
        });
      });
    },
    Delete(scope) {
      this.$confirm(
        "This will permanently delete the AI Model. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => this.deleteFaultReport(scope.row._id))
        .then(() => this.getAIModel(this.query))
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    Create() {
      this.editId = undefined;
      this.showForm = true;
    },
    Cancel() {
      this.editId = "";
      this.form = {
        customer: "",
      };
    },
    Edit(scope) {
      this.form = {
        customer: scope.row.customer,
      };
      this.editId = scope.row._id;
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>